import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {connect} from "@irati/store"
import {injectIntl} from "@irati/utils/lang"
import {BlockNavigationActions, BlockRefresh} from "@irati/utils/history/routing"
import GetInsWizard from "@irati/insights/apollo/client/query/InsWizard"
import GetCycleWizard from "@irati/insights/apollo/query/wizard/Cycle"
import SaveCycleAndQuestions from "@irati/insights/apollo/mutation/wizard/SaveCycleAndQuestions"

import Modal from "../../../ui/Modal"
import cycleCloneHasChanges from "../../../helpers/cycle/cycleCloneHasChanges"
import questionsCloneHasChanges from "../../../helpers/cycle/questionsCloneHasChanges"


class NavigationBlocker extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    unblockNavigation: PropTypes.func.isRequired
  }

  handleGoBack = () => {
    const {unblockNavigation} = this.props
    unblockNavigation(true)
  }

  handleCancel = () => {
    const {unblockNavigation} = this.props
    unblockNavigation(false)
  }

  getModalPropValues = (hasChanges, isEdit, handleSave) => {
    const {formatMessage} = this.props
    if (hasChanges && isEdit) {
      return {
        primary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.saveAndGoBack"}),
          onClick: () => handleSave()
        },
        secondary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.goBackWithoutSaving"}),
          onClick: this.handleGoBack
        },
        title: formatMessage({id: "insights.navBlocker.modal.title.option1"}),
        description: formatMessage({id: "insights.navBlocker.modal.body.option3"})
      }
    } else if (hasChanges) {
      return {
        primary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.saveAndGoBack"}),
          onClick: () => handleSave()
        },
        secondary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.goBackWithoutSaving"}),
          onClick: this.handleGoBack
        },
        title: formatMessage({id: "insights.navBlocker.modal.title.option1"}),
        description: formatMessage({id: "insights.navBlocker.modal.body.option1"})
      }
    } else {
      return {
        primary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.goBack"}),
          onClick: this.handleGoBack
        },
        secondary: {
          text: formatMessage({id: "insights.navBlocker.modal.cta.cancel"}),
          onClick: this.handleCancel
        },
        title: formatMessage({id: "insights.navBlocker.modal.title.option2"}),
        description: formatMessage({id: "insights.navBlocker.modal.body.option2"})
      }
    }
  }

  render() {
    return (
      <GetCycleWizard useLoader={false}>
        {({schedule: {id: cycleId}, loading}) => (
          <GetInsWizard>
            {({cycle, questions, client, isEditMode}) => {
              const cycleChanges = cycleCloneHasChanges(client, cycle)
              const questionsChanges = questionsCloneHasChanges(client, questions, cycleId)
              const hasChanges = cycleChanges || questionsChanges
              return (
                <SaveCycleAndQuestions onCompleted={this.handleGoBack}>
                  {(handleSave, {loading: mutationLoading}) => {
                    const modalProps = this.getModalPropValues(hasChanges, isEditMode, handleSave)
                    const {primary, secondary, title, description} = modalProps
                    return (
                      <BlockRefresh block={!loading && hasChanges}>
                        <Modal
                          primary={primary}
                          secondary={secondary}
                          show
                          loading={mutationLoading}
                          handleClose={this.handleCancel}
                          title={title}>
                          {description}
                        </Modal>
                      </BlockRefresh>
                    )
                  }}
                </SaveCycleAndQuestions>
              )
            }}
          </GetInsWizard>
        )}
      </GetCycleWizard>

    )
  }
}


const actions = (dispatch) => {
  return {
    unblockNavigation: (bool) => dispatch(BlockNavigationActions.unblock(bool))
  }
}
export default injectIntl(connect(null, actions)(NavigationBlocker))
